// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TUb_","colBig":"styles_colBig__1G_jd","colSmall":"styles_colSmall__2F-OH"};